var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 225.61 243.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-6{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-7,.cls-9{fill:#fff;}.cls-4{fill:#08b9f4;}.cls-13,.cls-5{fill:#f45208;}.cls-5,.cls-6,.cls-7{stroke:#272726;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}.cls-8{fill:#272726;}.cls-9{isolation:isolate;}.cls-14,.cls-9{opacity:0.5;}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:#f4a608;}.cls-12{clip-path:url(#clip-path-3);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-291.46 -75.59)"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "741.01 318.38 133.81 323.15 -266.53 -23.18 340.67 -27.94"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-291.46 -75.59)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 385.56,
    y: 252.93,
    width: 90.34,
    height: 22.43,
    rx: 3.49
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-291.46 -75.59)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.15,289.66H356.47l7-23.76a2.51,2.51,0,0,1,2.41-1.79h1.89a2.5,2.5,0,0,1,2.39,1.79Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.47,
    y: 114.8,
    width: 52.46,
    height: 11.12,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.47,
    y: 125.93,
    width: 52.46,
    height: 11.13,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 100.47,
    y: 137.06,
    width: 52.46,
    height: 11.13,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.47,
    y: 114.8,
    width: 47.43,
    height: 11.12,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.47,
    y: 125.93,
    width: 47.43,
    height: 11.13,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 100.47,
    y: 137.06,
    width: 47.43,
    height: 11.13,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M413.86,153.56l1.38,5.66a2.17,2.17,0,0,0,2.05,1.62h1.76a2.17,2.17,0,0,0,2.06-1.62l1.37-5.66",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 122.72,
    y: 1,
    width: 7.98,
    height: 75.27
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 119.75,
    y: 72.67,
    width: 13.91,
    height: 5.29,
    rx: 2.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M422.47,170.39a4.32,4.32,0,1,1-4.32-4.32v-5.25",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M436.72,190.39l-16.79-16.8a2.47,2.47,0,0,0-3.5,0h0l-16.81,16.8",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.47,
    y: 114.8,
    width: 52.46,
    height: 11.12,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.47,
    y: 125.93,
    width: 52.46,
    height: 11.13,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 100.47,
    y: 137.06,
    width: 52.46,
    height: 11.13,
    rx: 4.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 108.53,
    cy: 120.36,
    r: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 2.69,
    y1: 169.47,
    x2: 2.69,
    y2: 194.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 166.31,
    width: 11.11,
    height: 11.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 11.51,
    y: 191.52,
    width: 6.09,
    height: 6.09
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M485.55,213.61v-2.27l-2.07-.46a7.21,7.21,0,0,0-1-2.29l1.13-1.79-1.6-1.55-1.79,1.08a7.08,7.08,0,0,0-2.29-1l-.47-2.07h-2.3l-.47,2.07a7.08,7.08,0,0,0-2.29,1l-1.75-1.08-1.6,1.6,1.08,1.79a7.33,7.33,0,0,0-1,2.29l-2.06.47v2.26l2.06.47a7.33,7.33,0,0,0,1,2.29l-1.08,1.79,1.6,1.6,1.79-1.14a7,7,0,0,0,2.29,1l.47,2.08h2.26l.47-2.08a7.08,7.08,0,0,0,2.29-1l1.79,1.14,1.6-1.6-1.13-1.79a7.31,7.31,0,0,0,1-2.29Z",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470,295s.59-4.32-1.76-6.71a4.71,4.71,0,0,1,3.66,3.36S473.45,287,477,286c0,0-3.83,4.39-1.43,9.07",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M311.14,295s-.6-4.32,1.75-6.71a4.72,4.72,0,0,0-3.66,3.32s-1.54-4.66-5.07-5.71c0,0,3.81,4.38,1.43,9.07",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M477.11,250.16v-4.51l-4.14-.94a14.48,14.48,0,0,0-1.9-4.58l2.26-3.59-3.24-3.24-3.59,2.26a14.52,14.52,0,0,0-4.58-1.9l-.94-4.13h-4.51l-.94,4.13a14.72,14.72,0,0,0-4.58,1.9l-3.58-2.26-3.24,3.24,2.26,3.59a14.32,14.32,0,0,0-1.91,4.58l-4.13.94v4.51l4.13.93a14.15,14.15,0,0,0,1.91,4.59l-2.18,3.57,3.24,3.24,3.59-2.27a14.55,14.55,0,0,0,4.58,1.91l.94,4.12h4.51l.94-4.12a14.74,14.74,0,0,0,4.58-1.91l3.58,2.27,3.24-3.24-2.25-3.59a14.68,14.68,0,0,0,1.9-4.59Z",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "110.08 167.77 110.08 219.44 105.74 219.44 105.74 167.77"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 107.91,
    cy: 167.77,
    r: 4.09
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "172.83 167.77 172.83 219.44 168.49 219.44 168.49 167.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M466.21,243.36a4.11,4.11,0,1,1-4.1-4.1h0A4.1,4.1,0,0,1,466.21,243.36Z",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 135.04,
    y1: 219.44,
    x2: 53.5,
    y2: 219.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 197.69,
    y1: 219.44,
    x2: 164.62,
    y2: 219.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 25.87,
    y1: 219.44,
    x2: 9.34,
    y2: 219.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 156.96,
    y1: 219.44,
    x2: 156.96,
    y2: 219.44
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 48.53,
    y1: 219.44,
    x2: 48.53,
    y2: 219.44
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "117.61 164.37 84.29 209.6 70.79 209.6 104.11 164.37 117.61 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "144.61 164.37 111.29 209.6 97.8 209.6 131.11 164.37 144.61 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "171.62 164.37 138.29 209.6 124.79 209.6 158.11 164.37 171.62 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "198.62 164.37 165.3 209.6 151.79 209.6 185.12 164.37 198.62 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "104.11 164.37 70.79 209.6 57.29 209.6 90.6 164.37 104.11 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "131.11 164.37 97.8 209.6 84.29 209.6 117.61 164.37 131.11 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "158.11 164.37 124.79 209.6 111.29 209.6 144.61 164.37 158.11 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "185.12 164.37 151.79 209.6 138.29 209.6 171.62 164.37 185.12 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "212.11 164.37 178.8 209.6 165.3 209.6 198.62 164.37 212.11 164.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "225.61 164.37 192.3 209.6 178.8 209.6 212.11 164.37 225.61 164.37"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 94.11,
    y: 177.34,
    width: 90.34,
    height: 22.43,
    rx: 3.49
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.04 206.89 57.66 231.38 57.66 237.68 93.04 213.19 93.04 206.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.04 194.31 57.66 218.81 57.66 225.1 93.04 200.61 93.04 194.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.04 181.73 57.66 206.24 57.66 212.52 93.04 188.03 93.04 181.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.04 169.16 57.66 193.65 57.66 199.94 93.04 175.45 93.04 169.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.04 213.19 57.66 237.68 57.66 243.97 93.04 219.47 93.04 213.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.04 200.61 57.66 225.1 57.66 231.38 93.04 206.89 93.04 200.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.04 188.03 57.66 212.52 57.66 218.81 93.04 194.31 93.04 188.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.04 175.45 57.66 199.94 57.66 206.24 93.04 181.73 93.04 175.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.04 162.87 57.66 187.36 57.66 193.65 93.04 169.16 93.04 162.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "93.04 156.58 57.66 181.07 57.66 187.36 93.04 162.87 93.04 156.58"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M377.15,289.66H356.47l7-23.76a2.51,2.51,0,0,1,2.41-1.79h1.89a2.5,2.5,0,0,1,2.39,1.79Z",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M379.41,295H354.26a2.68,2.68,0,0,1-2.69-2.69h0a2.68,2.68,0,0,1,2.69-2.68h25.19a2.68,2.68,0,0,1,2.68,2.68h0a2.68,2.68,0,0,1-2.69,2.69Z",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 93.51,
    cy: 90.45,
    r: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M404.67,166a7.71,7.71,0,1,1-7.72-7.7h0A7.72,7.72,0,0,1,404.67,166Z",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M377.28,166.9a5.4,5.4,0,1,1-5.4-5.4A5.4,5.4,0,0,1,377.28,166.9Z",
    transform: "translate(-291.46 -75.59)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 170.29,
    cy: 106.79,
    r: 8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M473.78,182.39a4.71,4.71,0,1,1-4.71-4.71h0A4.71,4.71,0,0,1,473.78,182.39Z",
    transform: "translate(-291.46 -75.59)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M457,182.92a3.31,3.31,0,1,1-3.3-3.31h0A3.31,3.31,0,0,1,457,182.92Z",
    transform: "translate(-291.46 -75.59)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M372.29,215v-7.56l-6.89-1.54a23.9,23.9,0,0,0-3.17-7.65l3.78-6-5.27-5.36-6,3.77a23.82,23.82,0,0,0-7.64-3.16l-1.56-6.89H338l-1.55,6.89a23.91,23.91,0,0,0-7.64,3.16l-6-3.77-5.27,5.4,3.78,6a24,24,0,0,0-3.17,7.65l-6.94,1.5V215l6.88,1.56a23.91,23.91,0,0,0,3.18,7.63l-3.73,5.93,5.32,5.32,6-3.77a24,24,0,0,0,7.63,3.18L338,241.7h7.56l1.55-6.88a24.48,24.48,0,0,0,7.65-3.18l6,3.77,5.32-5.32-3.78-6a23.86,23.86,0,0,0,3.18-7.64Z",
    transform: "translate(-291.46 -75.59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/maintenance.0b006ce41dd24ea89d6c7ef0e4703b2f.svg";
export { ForwardRef as ReactComponent };